import React from 'react';
import useFetched from 'effects/use-fetched';
type Props = {
  pins?: {
    urls?: Array<string>;
    claimIds?: Array<string>;
    onlyPinForOrder?: string;
  };
  doResolveClaimIds: (arg0: Array<string>) => Promise<any>;
  doResolveUris: (arg0: Array<string>, arg1: boolean) => Promise<any>;
};
export default function useResolvePins(props: Props) {
  const { pins, doResolveClaimIds, doResolveUris } = props;
  const [resolvedPinUris, setResolvedPinUris] = React.useState(pins ? undefined : null);
  const [isResolving, setIsResolving] = React.useState(false);
  const hasResolvedPinUris = useFetched(isResolving); // Only attempt once

  React.useEffect(() => {
    if (resolvedPinUris === undefined && pins && !isResolving && !hasResolvedPinUris) {
      if (pins.claimIds) {
        setIsResolving(true);
        doResolveClaimIds(pins.claimIds)
          .then((result) => {
            const uris = [];

            if (result) {
              Object.values(result).forEach((r: any) => {
                const claim = r && r.stream;

                if (claim && pins.claimIds?.includes(claim.claim_id)) {
                  if (claim.canonical_url) {
                    uris.push(claim.canonical_url);
                  }
                }
              });
            }

            setResolvedPinUris(uris.length > 0 ? uris : null);
          })
          .finally(() => setIsResolving(false));
      } else if (pins.urls) {
        setIsResolving(true);
        doResolveUris(pins.urls, true).finally(() => {
          setIsResolving(false);
          setResolvedPinUris(pins.urls);
        });
      } else {
        setResolvedPinUris(null);
      }
    }
  }, [resolvedPinUris, pins, doResolveUris, doResolveClaimIds, isResolving, hasResolvedPinUris]);
  return resolvedPinUris;
}
